import { children } from "dom7";
import { version } from "./config";


const user = JSON.parse(localStorage.getItem("user"));
const advertiser_id = localStorage.getItem("advertiser_id"); //for hiding dashboard screen for pepsi advertiser

export let homeRoutes = {};
export let videoRoutes = {};
export let bannerRoutes = {};
export let serviceConfigurationRoutes ={};
export let reconciliationRoutes = {};
export let adApprovalRoutes = {};
export let deviceRoutes = {};
export let bandwidthReportRoutes = {};
export let clientRoutes = {};
export let outageRoutes = {};
export let demandRoutes = {};
export let demandPartnerRoutes = {};
export let demandSourceRoutes = {};
export let playlistRoutes = {};
export let campaignRoutes = {};
export let creativeManagementRoutes = {}
export let superReportRoutes = {};
export let demandReportRoutes = {};
export let merchantRoutes = {};
export let monthlyRoutes = {};
export let userNameRoutes = {};
export let emailsRoutes = {};
export let locationRoutes = {};
export let userManagementRoutes = {};
export let userDetailsRoutes = {};
export let settingsRoutes = {};
export let importRoutes = {};
export let pageRoutes = {};
export let chatRoutes = {};
export let emailRoutes = {};
export let authenticationRoutes = {};
export let ECommerceRoutes = {};
export let widgetsRoutes = {};
export let componentRoutes = {};
export let utilityRoutes = {};
export let pluginRoutes = {};
export let documentationRoutes = {};
export let changelogRoutes = {};
export let outagereportroutes = {};
export let advertiserroutes = {};
export let revenueanalyticsreportroutes = {};
export let partnerdetailsroutes = {};
export let integrationroutes = {};
export let healthreportroutes = {};
export let templateroutes = {};
export let rssfeedroutes = {};
export let bannerroutes = {};
export let display = {};
export let displayCampaignRoutes = {};
export let displayDemandRoutes = {};
export let audienceTargetingRoute = {};
export let videoAnalyticsReport = {};
export let doohAnalyticsReport = {};
export let placeExchangeLocationSearch = {};
export let CampaignPlanAdd = {}
export let tenantRoutes = {};
export let doohPlaylistRoutes = {};
export let demandAdApprovalRoutes = {};
export let deviceAppRoutes = {};
export let deviceAppListRoutes = {};

let demographicRoutes = {};

let newLocationRoutes = {};


if (user) {
  if (user.role === 26 && user.user_id === 1154) {
    homeRoutes = {
      name: "Home",
      to: "/",
      exact: true,
      icon: "home",
      children: [
        {
          to: "/",
          name: "Dashboard",
          icon: "chart-pie",
          exact: true,
        },
      ],
    };
    videoRoutes = {
      name: "Videos",
      to: "/components",
      icon: "video",
      children: [
        { to: "/videos", name: "List" },
      ],
    };
     bannerRoutes = {
      name: "Banner",
      to: "/components",
      icon: "image",
      children: [
        { to: "/banners", name: "List" },
      ],
    };
    deviceRoutes = {
      name: "Devices",
      to: "/components",
      icon: "tv",
      children: [
        { to: "/components/deviceList", name: "List" },
        { to: "/components/deviceAdd", name: "Add New" },
        { to: "/components/device/enquiry", name: "Inquiry"},
      ],
    };

    bandwidthReportRoutes = {
      name: "Bandwidth Report",
      to: "/components/bandwidthReport",
      icon: "wifi",
      exact: true,
    };

    clientRoutes = {
      name: "Clients",
      to: "/components",
      icon: "user",
      children: [
        { to: "/components/clientList", name: "List" },
        { to: "/components/clientAdd", name: "Add New" },
      ],
    };

    demandRoutes = {
      name: "Demand Manage",
      to: "/components",
      icon: "ad",
      children: [
        { to: "/components/demandSourceList", name: "Demand List" },
        { to: "/components/demandPartnerList", name: "Partner List" },
        { to: "/demand/mapping", name: "Demand Mapping" },
        { to: "/components/rtb/mapping", name: "RTB Mapping" },
      ],
    };

    revenueanalyticsreportroutes = {
      name: "Revenue Analytics ",
      to: "/components/revenueanalyticsreport",
      icon: "file-invoice-dollar",
    };

    demandPartnerRoutes = {
      name: "Demand Partner",
      to: "/components",
      icon: "users",
      children: [
        { to: "/components/demandPartnerList", name: "List" },
        { to: "/components/demandPartnerAdd", name: "Add New" },
      ],
    };

    campaignRoutes = {
      name: "Video Campaigns",
      to: "/components",
      icon: "play",
      children: [
        { to: "/components/campaignList", name: "List" },
        { to: "/components/ActiveList", name: " Active List" },
        { to: "/components/campaignReport", name: "Report" },
        {to: "/components/combinedReport", name: "Granular Report"},
        {
          name :"Plan Search",
          to : "/components/planSearch",
          icon : "search",
        },
        // { to: "/components/campaignReport/new", name: "Report New" },
        { to: "/components/placeExchange", name: " Place Exchange Report"},
        (audienceTargetingRoute = {
          name: "Audience Target",
          to: "/components",
          icon: "lock",
          children: [
            {
              to: "/components/campaign/audienceTarget/add",
              name: "Add",
            },
            {
              to: "/components/campaign/audienceTarget/list",
              name: "List",
            },
          ],
        }),
        (advertiserroutes = {
          name: "Advertiser",
          to: "/components",
          icon: "lock",
          children: [
            {
              to: "/components/CampaignPaymentAdmn",
              name: "Advertiser Payment",
            },
            {
              to: "/components/advertiserstatement",
              name: "Advertiser Statement",
            },
            { to: "/components/paymentReport", name: "Payment Details" },
          ],
        }),
      ],
    };

    creativeManagementRoutes = {
      name :"Creative Management",
      to : "/components",
      icon : "photo-video",
      children : [
        {to : "/components/creativeManageList", name : "List"},
        {to : "/components/creativeManageAdd", name : "Add New"},
      ],
    }

    superReportRoutes = {
      name: "Super Admin Report",
      to: "/components/superReport",
      icon: "user-tie",
    };

    demandReportRoutes = {
      name: "Demand Report",
      to: "/components/demandReport",
      icon: "poll",
    };

    userNameRoutes = {
      name: "Network",
      to: "/components",
      icon: "cubes",
      children: [
        { to: "/components/userNameList", name: "List" },
        { to: "/components/userNameAdd", name: "Add New" },
      ],
    };

    locationRoutes = {
      name: "Locations",
      to: "/components",
      icon: "map-marked",
      children: [
        { to: "/components/locationList", name: "List" },
        { to: "/components/locationAdd", name: "Add New" },
      ],
    };

    userManagementRoutes = {
      name: "User Manage",
      to: "/components",
      icon: "book",
      children: [
        { to: "/components/clientList", name: "List" },
        { to: "/components/clientAdd", name: "Add User" },
      ],
    };

    userDetailsRoutes = {
      name: "User Manage",
      to: "/components",
      icon: "users-cog",
      children: [
        { to: "/components/userList", name: "List" },
        { to: "/components/userAdd", name: "Add User" },
      ],
    };
  }
   else if (user.role === 26 && user.user_id === 1228 && user.tenant_id === 335) {
    homeRoutes = {
      name: "DASHBOARD",
      to: "/",
      exact: true,
      icon: "gauge-high",
    };
    deviceRoutes = {
      name: "SCREENS",
      to: "/components",
      icon: "tv",
      children: [
        { to: "/components/deviceList", name: "List" },
        { to: "/components/deviceAdd", name: "Add New" },

      ],
    };

    clientRoutes = {
      name: "CLIENTS",
      to: "/components",
      icon: "briefcase",
      children: [
        { to: "/components/clientList", name: "List" },
        { to: "/components/clientAdd", name: "Add New" },
      ],
    };

    demandRoutes = {
      name: "PROGRAMMATIC",
      to: "/components",
      icon: "ad",
      children: [
        { to: "/components/demandSourceList", name: "Line Item" },
        { to: "/components/demandPartnerList", name: "Partners" },
        { to: "/component", name: "Mapping", children: [
          { to: "/demand/mapping", name: "VAST/API" },
          { to: "/components/rtb/mapping", name: "RTB" },
          { to: `/offlineDemand/mapping`, name: "Offline" },
        ] },
      ],
    };

    campaignRoutes = {
      name: "ADSERVER",
      to: "/components",
      icon: "bullhorn",
      children: [
        { to: "/components/campaignAdd", name: "Add New" },
        { to: "/components/campaignList", name: "List" },
        { to: "/components/ActiveList", name: " Active Campaigns" },
        // {
        //   to: "/components",
        //   name: "Report",
        //   children: [
        //     { to: "/components/campaignReport", name: "Performance" },
        //     { to: "/components/combinedReport", name: "Granular" }
        //   ]
        // }
      ],
    };

    creativeManagementRoutes = {
      name: "CREATIVE LIBRARY",
      to: "/components",
      icon: "photo-film",
      children: [
        { to: "/components/creativeManageList", name: "List" },
        { to: "/components/creativeManageAdd", name: "Add New" },
      ],
    };

    superReportRoutes = {
      name: "ANALYTICS",
      to: "/components",
      icon: "chart-area",
      children: [
      { to: "/components/superReport", name: "Global"},
      { to: "/components/revenueanalyticsreport", name: "Revenue" },
      { to: "/components/demandReport", name: "Demand Report" },
      { to: "/components/outagereport", name: "Outage"},
      { to: "/components/videoAnalyticsReport", name: "Local Video" },
      { to: "/components/doohAnalyticsReport", name: "Loop Analytics Report" },
      ],
    };
    userNameRoutes = {
      name: "NETWORKS",
      to: "/components",
      icon: "mountain-city",
      children: [
        { to: "/components/userNameList", name: "List" },
        { to: "/components/userNameAdd", name: "Add New" },
      ],
    };

    locationRoutes = {
      name: "VENUES",
      to: "/components",
      icon: "shop",
      children: [
        { to: "/components/locationList", name: "List" },
        { to: "/components/locationAdd", name: "Add New" },
      ],
    };
    // userDetailsRoutes = {
    //   name: "USERS",
    //   to: "/components",
    //   icon: "user-astronaut",
    //   children: [
    //     { to: "/components/userList", name: "List" },
    //     { to: "/components/userAdd", name: "Add User" },
    //   ],
    // };
    // Hide USERS menu for this user
    

    partnerdetailsroutes = {
      name: "LABS",
      to: "/components",
      border: true,
      icon: "flask",
      children: [
        { name: "Intel Partner Details", to: "/components/Partnerdetails" },
        {
          name: "Template",
          to: "/components",
          children: [
            { to: "/components/templateadd", name: "Template Add" },
            { to: "/components/templatelist", name: "Template List" },
            { to: "/components/createtheme", name: "Theme Create" },
            { to: "/components/themelist", name: "Theme List" },
            {
              name: "Banner",
              to: "/components",
              children: [
                { to: "/components/bannerupload", name: "Banner Upload" },
                { to: "/components/bannerlist", name: "Banner List" },
              ],
            },
            {
              name: "RSS Feed",
              to: "/components",
              children: [
                { to: "/components/rssfeedadd", name: "RSS Feed Add" },
                { to: "/components/rssfeedlist", name: "RSS Feed List" },
              ],
            },
          ],
        },
      ],
    };
    } else if (user.role === 26 && user.user_id === 1272 && user.tenant_id === 335) {
    homeRoutes = {
      name: "DASHBOARD",
      to: "/",
      exact: true,
      icon: "gauge-high",
    };
    deviceRoutes = {
      name: "SCREENS",
      to: "/components",
      icon: "tv",
      children: [
        { to: "/components/deviceAdd", name: "Add New" },

      ],
    };

    clientRoutes = {
      name: "CLIENTS",
      to: "/components",
      icon: "briefcase",
      children: [
        { to: "/components/clientAdd", name: "Add New" },
      ],
    };

    demandRoutes = {
      name: "PROGRAMMATIC",
      to: "/components",
      icon: "ad",
      children: [
      { to: "/components/demandSourceList", name: "Line Item" },
      { to: "/components/demandPartnerList", name: "Partners" },
      { to: "/component", name: "Mapping", children: [
        { to: "/demand/mapping", name: "VAST/API" },
        { to: "/components/rtb/mapping", name: "RTB" },
        { to: `/offlineDemand/mapping`, name: "Offline" },
      ] },
      ],
    };

    campaignRoutes = {
      name: "ADSERVER",
      to: "/components",
      icon: "bullhorn",
      children: [
        {to: "/components/campaignAdd", name: "Add New"},
        { to: "/components/campaignList", name: "List" },
        { to: "/components/ActiveList", name: " Active Campaigns" },
        {name: "Videos",
          to: "/components",
          children: [
              { to: "/videos", name: "List" },
      ],},
        { to: "/components", name: "Report", children: [
          { to: "/components/campaignReport", name: "Performance" },
          { to: "/components/combinedReport", name: "Granular" }
        ] },
        ],
    };

    creativeManagementRoutes = {
      name: "CREATIVE LIBRARY",
      to: "/components",
      icon: "photo-film",
      children: [
      { to: "/components/creativeManageList", name: "List" },
      { to: "/components/creativeManageAdd", name: "Add New" },
      ],
    };

    superReportRoutes = {
      name: "ANALYTICS",
      to: "/components",
      icon: "chart-area",
      children: [
      // { to: "/components/superReport", name: "Global"},
      // { to: "/components/revenueanalyticsreport", name: "Revenue" },
      // { to: "/components/demandReport", name: "Demand Report" },
      // { to: "/components/outagereport", name: "Outage"},
      // { to: "/components/videoAnalyticsReport", name: "Local Video" },
      { to: "/components/doohAnalyticsReport", name: "Loop Playback Report" },
      ],
    };
    userNameRoutes = {
      name: "NETWORKS",
      to: "/components",
      icon: "mountain-city",
      children: [
        { to: "/components/userNameAdd", name: "Add New" },
      ],
    };

    locationRoutes = {
      name: "VENUES",
      to: "/components",
      icon: "shop",
      children: [
        { to: "/components/locationAdd", name: "Add New" },
      ],
    };

    partnerdetailsroutes = {
      name: "LABS",
      to: "/components",
      border: true,
      icon: "flask",
      children: [
        { name: "Intel Partner Details", to: "/components/Partnerdetails" },
        {
          name: "Template",
          to: "/components",
          children: [
            { to: "/components/templateadd", name: "Template Add" },
            { to: "/components/templatelist", name: "Template List" },
            { to: "/components/createtheme", name: "Theme Create" },
            { to: "/components/themelist", name: "Theme List" },
            {
              name: "Banner",
              to: "/components",
              children: [
                { to: "/components/bannerupload", name: "Banner Upload" },
                { to: "/components/bannerlist", name: "Banner List" },
              ],
            },
            {
              name: "RSS Feed",
              to: "/components",
              children: [
                { to: "/components/rssfeedadd", name: "RSS Feed Add" },
                { to: "/components/rssfeedlist", name: "RSS Feed List" },
              ],
            },
          ],
        },
      ],
    };
    }
 else if (user.role === 26 && user.tenant_id === 1) {
    homeRoutes = {
      name: "Home",
      to: "/",
      exact: true,
      icon: "home",
      children: [
        {
          to: "/",
          name: "Dashboard",
          icon: "chart-pie",
          exact: true,
        },
      ],
    };
    healthreportroutes = {
      name: "Health Report",
      to: "/components/healthreports",
      icon: "file-medical",
    };
    partnerdetailsroutes = {
      name: " Intel Partner Details",
      to: "/components/Partnerdetails",
      icon: "poll",
    };
    videoRoutes = {
      name: "Videos",
      to: "/components",
      icon: "video",
      children: [
        { to: "/videos", name: "List" },
      ],
    };
    bannerRoutes = {
      name: "Banner",
      to: "/components",
      icon: "image",
      children: [
        { to: "/banners", name: "List" },
      ],
    };
    integrationroutes = {
      name: "Integration",
      to: "/components",
      icon: "copy",
      children: [
        { to: "/components/integrationadd", name: "Integration Add" },
        { to: "/components/integrationlist", name: "Integration List" },
      ],
    };
    deviceRoutes = {
      name: "Devices",
      to: "/components",
      icon: "tv",
      children: [
        { to: "/components/deviceList", name: "List" },
        { to: "/components/deviceAdd", name: "Add New" },
        { to: "/components/device/enquiry", name: "Inquiry"},

      ],
    };

    clientRoutes = {
      name: "Clients",
      to: "/components",
      icon: "user",
      children: [
        { to: "/components/clientList", name: "List" },
        { to: "/components/clientAdd", name: "Add New" },
      ],
    };

    demandRoutes = {
      name: "Demand Manage",
      to: "/components",
      icon: "ad",
      children: [
        { to: "/components/demandSourceList", name: "Demand List" },
        { to: "/components/demandPartnerList", name: "Partner List" },
        { to: "/demand/mapping", name: "Demand Mapping" },
        { to: "/components/rtb/mapping", name: "RTB Mapping" },
        { to: `/offlineDemand/mapping`, name: "Offline Demand Mapping" },
      ],
    };

    serviceConfigurationRoutes = {
      name: "Service Configuration",
      to: "/components",
      icon:"cog",
      children: [
        { to: "/components/ServiceConfiguration", name: "List" }
      ]
    }

    reconciliationRoutes = {
      icon:"balance-scale-left",
      to: "/components/Reconciliation", name: "Reconciliation",
    }

    revenueanalyticsreportroutes = {
      name: "Revenue Analytics ",
      to: "/components/revenueanalyticsreport",
      icon: "file-invoice-dollar",
    };

    demandPartnerRoutes = {
      name: "Demand Partner",
      to: "/components",
      icon: "users",
      children: [
        { to: "/components/demandPartnerList", name: "List" },
        { to: "/components/demandPartnerAdd", name: "Add New" },
      ],
    };

    campaignRoutes = {
      name: "Video Campaigns",
      to: "/components",
      icon: "play",
      children: [
        { to: "/components/campaignList", name: "List" },
        { to: "/components/ActiveList", name: " Active List" },
        { to: "/components/campaignReport", name: "Report" },
        {to: "/components/combinedReport", name: "Granular Report"},
        {
          name :"Plan Search",
          to : "/components",
          icon : "search",
          children:[
            {to: "/components/planning/List", name: "Plan List"},
            {to: "/components/planning/planSearchNew", name: "Search plan"},
          ]
        },
        // { to: "/components/campaignReport/new", name: "Report New" },
        { to: "/components/placeExchange", name: " Place Exchange Report"},
        (audienceTargetingRoute = {
          name: "Audience Target",
          to: "/components",
          icon: "lock",
          children: [
            {
              to: "/components/campaign/audienceTarget/add",
              name: "Add",
            },
            {
              to: "/components/campaign/audienceTarget/list",
              name: "List",
            },
          ],
        }),
        (advertiserroutes = {
          name: "Advertiser",
          to: "/components",
          icon: "lock",
          children: [
            {
              to: "/components/CampaignPaymentAdmn",
              name: "Advertiser Payment",
            },
            {
              to: "/components/advertiserstatement",
              name: "Advertiser Statement",
            },
            { to: "/components/paymentReport", name: "Payment Details" },
          ],
        }),
      ],
    };

    creativeManagementRoutes = {
      name :"Creative Management",
      to : "/components",
      icon : "photo-video",
      children : [
        {to : "/components/creativeManageList", name : "List"},
        {to : "/components/creativeManageAdd", name : "Add New"},
      ],
    }

    superReportRoutes = {
      name: "Super Admin Report",
      to: "/components/superReport",
      icon: "user-tie",
    };

    outagereportroutes = {
      name: "Outage Report",
      to: "/components/outagereport",
      icon: "lock",
    };

    merchantRoutes = {
      name: "Merchant Statement",
      to: "/components/merchantStatement",
      icon: "copy",
    };

    demandReportRoutes = {
      name: "Demand Report",
      to: "/components/demandReport",
      icon: "poll",
    };

    userNameRoutes = {
      name: "Networks",
      to: "/components",
      icon: "cubes",
      children: [
        { to: "/components/userNameList", name: "List" },
        { to: "/components/userNameAdd", name: "Add New" },
      ],
    };

    userManagementRoutes = {
      name: "User Manage",
      to: "/components",
      icon: "book",
      children: [
        { to: "/components/clientList", name: "List" },
        { to: "/components/clientAdd", name: "Add User" },
      ],
    };

    userDetailsRoutes = {
      name: "User Manage",
      to: "/components",
      icon: "users-cog",
      children: [
        { to: "/components/userList", name: "List" },
        { to: "/components/userAdd", name: "Add User" },
      ],
    };

    settingsRoutes = {
      name: "Settings",
      to: "/components",
      icon: "code-branch",
      children: [
        { to: "/components/clientList", name: "Reset Password" },
        { to: "/components/clientAdd", name: "Offline Video" },
      ],
    };

    authenticationRoutes = {
      name: "Authentication",
      to: "/authentication",
      icon: "lock",
      children: [
        {
          to: "/authentication/basic",
          name: "Basic",
          children: [
            { to: "/authentication/basic/login", name: "Login" },
            { to: "/authentication/basic/logout", name: "Logout" },
            { to: "/authentication/basic/register", name: "Register" },
            {
              to: "/authentication/basic/forget-password",
              name: "Forgot password",
            },
            {
              to: "/authentication/basic/password-reset",
              name: "Reset password",
            },
            { to: "/authentication/basic/confirm-mail", name: "Confirm mail" },
            { to: "/authentication/basic/lock-screen", name: "Lock screen" },
          ],
        },
        {
          to: "/authentication/card",
          name: "Card",
          children: [
            { to: "/authentication/card/login", name: "Login" },
            { to: "/authentication/card/logout", name: "Logout" },
            { to: "/authentication/card/register", name: "Register" },
            {
              to: "/authentication/card/forget-password",
              name: "Forgot password",
            },
            {
              to: "/authentication/card/password-reset",
              name: "Reset password",
            },
            { to: "/authentication/card/confirm-mail", name: "Confirm mail" },
            { to: "/authentication/card/lock-screen", name: "Lock screen" },
          ],
        },
        {
          to: "/authentication/split",
          name: "Split",
          children: [
            { to: "/authentication/split/login", name: "Login" },
            { to: "/authentication/split/logout", name: "Logout" },
            { to: "/authentication/split/register", name: "Register" },
            {
              to: "/authentication/split/forget-password",
              name: "Forgot password",
            },
            {
              to: "/authentication/split/password-reset",
              name: "Reset password",
            },
            { to: "/authentication/split/confirm-mail", name: "Confirm mail" },
            { to: "/authentication/split/lock-screen", name: "Lock screen" },
          ],
        },
        {
          to: "/authentication/wizard",
          name: "Wizard",
        },
      ],
    };

    ECommerceRoutes = {
      name: "E commerce",
      to: "/e-commerce",
      icon: "cart-plus",
      children: [
        { to: "/e-commerce/products/list", name: "Product list" },
        { to: "/e-commerce/products/grid", name: "Product grid" },
        { to: "/e-commerce/product-details", name: "Product details" },
        { to: "/e-commerce/orders", name: "Orders" },
        { to: "/e-commerce/order-details", name: "Order details" },
        { to: "/e-commerce/customers", name: "Customers" },
        { to: "/e-commerce/shopping-cart", name: "Shopping cart" },
        { to: "/e-commerce/checkout", name: "Checkout" },
        { to: "/e-commerce/favourite-items", name: "Favourite items" },
      ],
    };

    pageRoutes = {
      name: "Pages",
      to: "/pages",
      icon: "copy",
      children: [
        { to: "/pages/activity", name: "Activity" },
        { to: "/pages/associations", name: "Associations" },
        { to: "/pages/billing", name: "Billing" },
        { to: "/pages/customer-details", name: "Customer details" },
        { to: "/pages/event-detail", name: "Event detail" },
        { to: "/pages/event-create", name: "Event create" },
        { to: "/pages/events", name: "Events" },
        { to: "/pages/faq", name: "Faq" },
        { to: "/pages/invoice", name: "Invoice" },
        { to: "/pages/invite-people", name: "Invite people" },
        { to: "/pages/notifications", name: "Notifications" },
        { to: "/pages/people", name: "People" },
        { to: "/pages/pricing", name: "Pricing" },
        { to: "/pages/pricing-alt", name: "Pricing alt" },
        { to: "/pages/profile", name: "Profile" },
        { to: "/pages/settings", name: "Settings" },
        { to: "/pages/starter", name: "Starter" },
        {
          to: "/errors",
          name: "Errors",
          children: [
            { to: "/errors/404", name: "404" },
            { to: "/errors/500", name: "500" },
          ],
        },
      ],
    };
    widgetsRoutes = {
      name: "Widgets",
      to: "/widgets",
      exact: true,
      icon: "poll",
      badge: {
        text: `New`,
        color: "soft-success",
      },
    };

    chatRoutes = {
      name: "Chat",
      to: "/chat",
      exact: true,
      icon: "comments",
    };

    emailRoutes = {
      name: "Email",
      to: "/email",
      icon: "envelope-open",
      children: [
        { to: "/email/inbox", name: "Inbox" },
        { to: "/email/email-detail", name: "Email detail" },
        { to: "/email/compose", name: "Compose" },
      ],
    };

    documentationRoutes = {
      name: "Documentation",
      to: "/documentation",
      exact: true,
      icon: "book",
    };

    changelogRoutes = {
      name: "ChangeLog",
      to: "/changelog",
      exact: true,
      icon: "code-branch",
      badge: {
        text: `v${version}`,
        color: "soft-primary",
      },
    };

    componentRoutes = {
      name: "Clients",
      to: "/components",
      icon: "puzzle-piece",
      children: [
        { to: "/components/alerts", name: "Alerts" },
        { to: "/components/accordions", name: "Accordions" },
        { to: "/components/avatar", name: "Avatar" },
        { to: "/components/badges", name: "Badges" },
        { to: "/components/backgrounds", name: "Backgrounds" },
        { to: "/components/breadcrumb", name: "Breadcrumb" },
        { to: "/components/buttons", name: "Buttons" },
        { to: "/components/cards", name: "Cards" },
        { to: "/components/collapses", name: "Collapses" },
        {
          to: "/components/carousel",
          name: "Carousel",
          badge: {
            text: `New`,
          },
        },
        { to: "/components/dropdowns", name: "Dropdowns" },
        { to: "/components/forms", name: "Forms" },
        { to: "/components/listgroups", name: "List groups" },
        { to: "/components/modals", name: "Modals" },
        { to: "/components/navs", name: "Navs" },
        { to: "/components/navbars", name: "Navbars" },
        {
          to: "/components/navbar-top",
          name: "Navbar Top",
          badge: {
            text: `New`,
          },
        },
        { to: "/components/pageheaders", name: "Page headers" },
        { to: "/components/paginations", name: "Paginations" },
        { to: "/components/popovers", name: "Popovers" },
        { to: "/components/progress", name: "Progress" },
        {
          to: "/components/sidepanel",
          name: "Sidepanel",
          badge: {
            text: "New",
          },
        },
        {
          to: "/components/spinners",
          name: "Spinners",
          badge: {
            text: `New`,
          },
        },

        { to: "/components/tables", name: "Tables" },
        { to: "/components/clientList", name: "Client List" },
        { to: "/components/clientAdd", name: "Client Add" },
        { to: "/components/clientEdit", name: "Client Edit" },
        { to: "/components/tooltips", name: "Tooltips" },
      ],
    };
    pluginRoutes = {
      name: "Plugins",
      to: "/plugins",
      icon: "plug",
      children: [
        { to: "/plugins/bulk-select", name: "Bulk select" },
        {
          to: "/plugins",
          name: "Chart",
          children: [
            { to: "/plugins/chart", name: "Chart Js" },
            { to: "/plugins/echarts", name: "Echarts" },
          ],
        },
        { to: "/plugins/countup", name: "Countup" },
        { to: "/plugins/code-highlight", name: "Code Highlight" },

        { to: "/plugins/datetime", name: "Datetime" },
        { to: "/plugins/dropzone", name: "Dropzone" },
        { to: "/plugins/emoji-mart", name: "Emoji Mart" },
        { to: "/plugins/fontawesome", name: "Fontawesome" },

        { to: "/plugins/image-lightbox", name: "Image lightbox" },
        { to: "/plugins/lottie", name: "Lottie" },
        {
          to: "/plugins",
          name: "Map",
          children: [
            { to: "/plugins/leaflet-map", name: "Leaflet map" },
            { to: "/plugins/google-map", name: "Google map" },
            { to: "/plugins/echart-map", name: "Echart Map" },
          ],
        },
        { to: "/plugins/progressbar", name: "Progressbar" },
        { to: "/plugins/react-hook-form", name: "React Hook Form" },
        { to: "/plugins/select", name: "Select" },
        { to: "/plugins/slick-carousel", name: "Slick Carousel" },
        { to: "/plugins/scroll-bar", name: "Scroll Bar" },
        { to: "/plugins/toastify", name: "Toastify" },
        { to: "/plugins/typed", name: "Typed" },
        { to: "/plugins/wysiwyg", name: "WYSIWYG editor" },
      ],
    };

    utilityRoutes = {
      name: "Utilities",
      to: "/utilities",
      icon: ["fab", "hotjar"],
      children: [
        { to: "/utilities/borders", name: "Borders" },
        { to: "/utilities/clearfix", name: "Clearfix" },
        { to: "/utilities/closeIcon", name: "Close icon" },
        { to: "/utilities/colors", name: "Colors" },
        { to: "/utilities/display", name: "Display" },
        { to: "/utilities/embed", name: "Embed" },
        { to: "/utilities/figures", name: "Figures" },
        { to: "/utilities/flex", name: "Flex" },
        { to: "/utilities/grid", name: "Grid" },
        { to: "/utilities/sizing", name: "Sizing" },
        { to: "/utilities/spacing", name: "Spacing" },
        { to: "/utilities/stretchedLink", name: "Stretched link" },
        { to: "/utilities/typography", name: "Typography" },
        { to: "/utilities/verticalAlign", name: "Vertical align" },
        { to: "/utilities/visibility", name: "Visibility" },
      ],
    };
    templateroutes = {
      name: "Template",
      to: "/components",
      icon: "copy",
      children: [
        { to: "/components/templateadd", name: "Template Add" },
        { to: "/components/templatelist", name: "Template List" },
        { to: "/components/createtheme", name: "Theme Create" },
        { to: "/components/themelist", name: "Theme List" },
        (bannerroutes = {
          name: "Banner",
          to: "/components",
          icon: "copy",
          children: [
            { to: "/components/bannerupload", name: "Banner Upload" },
            { to: "/components/bannerlist", name: "Banner List" },
          ],
        }),
        (rssfeedroutes = {
          name: "RSS Feed",
          to: "/components",
          icon: "copy",
          children: [
            { to: "/components/rssfeedadd", name: "RSS Feed Add" },
            { to: "/components/rssfeedlist", name: "RSS Feed List" },
          ],
        }),
      ],
    };
    display = {
      name: "Banner Campaigns",
      to: "/components",
      icon: "image",
      children: [
        (displayCampaignRoutes = {
          name: "Campaign Manage",
          to: "/components",
          icon: "play",
          children: [
            { to: "/components/displayCampaignList", name: "List" },
            { to: "/components/displayCampaign/Report", name: "Report" },
          ],
        }),
        (displayDemandRoutes = {
          name: "Demand Manage",
          to: "/components",
          icon: "image",
          children: [
            {
              to: "/components/displayDemandSourceList",
              name: "Demand List",
            },
            { to: "/displayDemand/mapping", name: "Demand Mapping" },
            { to: "/components/displayDemandReport", name: "Demand Report" },
            {
              to: "/components/displayrevenueanalyticsreport",
              name: "Revenue Analytics ",
            },
          ],
        }),
      ],
    };

     videoAnalyticsReport = {
      name: "Video Analytics Report",
      to: "/components/videoAnalyticsReport",
      icon: "poll",
    };
    doohAnalyticsReport = {
      name: "Loop Analytics Report",
      to: "/components/doohAnalyticsReport",
      icon: "list",
    };

    demographicRoutes = {
      name: "Demographic Report",
      to: "/components/demographic/report",
      icon: "chart-area",

    }

    newLocationRoutes = {
      name: "Locations",
      to: "/components",
      icon: "map-marked",
      children: [
        { to: "/components/locationList", name: "List" },
        { to: "/components/locationAdd", name: "Add New" },
      ],
    };
  


  }
   else if (user.role === 31) {
    deviceAppRoutes = {
      name: "Device Add",
      to: "/components/deviceInstallAdd",
      icon: "tv",
    };
    deviceAppListRoutes = {
      name: "Device List",
      to: "/components/deviceInstallList",
      icon: "tv",
    };
  }
   else if (user.role === 32) {
    deviceAppRoutes = {
      name: "Device Add",
      to: "/components/deviceInstallAdd",
      icon: "tv",
    };
    deviceAppListRoutes = {
      name: "Device List",
      to: "/components/deviceInstallList",
      icon: "tv",
    };
  }
   else if (user.role === 26) {
    homeRoutes = {
      name: "Home",
      to: "/",
      exact: true,
      icon: "home",
      children: [
        {
          to: "/",
          name: "Dashboard",
          icon: "chart-pie",
          exact: true,
        },
      ],
    };
    healthreportroutes = {
      name: "Health Report",
      to: "/components/healthreports",
      icon: "file-medical",
    };
    videoRoutes = {
      name: "Videos",
      to: "/components",
      icon: "video",
      children: [
        { to: "/videos", name: "List" },
      ],
    };
    bannerRoutes = {
      name: "Banner",
      to: "/components",
      icon: "image",
      children: [
        { to: "/banners", name: "List" },
      ],
    };
    deviceRoutes = {
      name: "Devices",
      to: "/components",
      icon: "tv",
      children: [
        { to: "/components/deviceList", name: "List" },
        { to: "/components/deviceAdd", name: "Add New" },
        { to: "/components/device/enquiry", name: "Inquiry"},

      ],
    };

    bandwidthReportRoutes = {
      name: "Bandwidth Report",
      to: "/components/bandwidthReport",
      icon: "wifi",
      exact: true,
    };

    clientRoutes = {
      name: "Clients",
      to: "/components",
      icon: "user",
      children: [
        { to: "/components/clientList", name: "List" },
        { to: "/components/clientAdd", name: "Add New" },
      ],
    };

    demandRoutes = {
      name: "Demand Manage",
      to: "/components",
      icon: "ad",
      children: [
        { to: "/components/demandSourceList", name: "Demand List" },
        { to: "/components/demandPartnerList", name: "Partner List" },
        { to: "/demand/mapping", name: "Demand Mapping" },
        { to: "/components/rtb/mapping", name: "RTB Mapping" },
        { to: `/offlineDemand/mapping`, name: "Offline Demand Mapping" },
      ],
    };

    revenueanalyticsreportroutes = {
      name: "Revenue Analytics ",
      to: "/components/revenueanalyticsreport",
      icon: "file-invoice-dollar",
    };

    demandPartnerRoutes = {
      name: "Demand Partner",
      to: "/components",
      icon: "users",
      children: [
        { to: "/components/demandPartnerList", name: "List" },
        { to: "/components/demandPartnerAdd", name: "Add New" },
      ],
    };

    campaignRoutes = {
      name: "Video Campaigns",
      to: "/components",
      icon: "play",
      children: [
        { to: "/components/campaignList", name: "List" },
        { to: "/components/ActiveList", name: " Active List" },
        { to: "/components/campaignReport", name: "Report" },
        {
          name :"Plan Search",
          to : "/components",
          icon : "search",
          children:[
            {to: "/components/planning/List", name: "Plan List"},
            {to: "/components/planning/planSearchNew", name: "Search plan"},
          ]
        },
        // { to: "/components/campaignReport/new", name: "Report New" },
        (audienceTargetingRoute = {
          name: "Audience Target",
          to: "/components",
          icon: "lock",
          children: [
            {
              to: "/components/campaign/audienceTarget/add",
              name: "Add",
            },
            {
              to: "/components/campaign/audienceTarget/list",
              name: "List",
            },
          ],
        }),
      ],
    };

    creativeManagementRoutes = {
      name :"Creative Management",
      to : "/components",
      icon : "photo-video",
      children : [
        {to : "/components/creativeManageList", name : "List"},
        {to : "/components/creativeManageAdd", name : "Add New"},
      ],
    }

    superReportRoutes = {
      name: "Super Admin Report",
      to: "/components/superReport",
      icon: "user-tie",
    };

    outagereportroutes = {
      name: "Outage Report",
      to: "/components/outagereport",
      icon: "lock",
    };

    merchantRoutes = {
      name: "Merchant Statement",
      to: "/components/merchantStatement",
      icon: "copy",
    };

    demandReportRoutes = {
      name: "Demand Report",
      to: "/components/demandReport",
      icon: "poll",
    };

    userNameRoutes = {
      name: "Networks",
      to: "/components",
      icon: "cubes",
      children: [
        { to: "/components/userNameList", name: "List" },
        { to: "/components/userNameAdd", name: "Add New" },
      ],
    };

    userManagementRoutes = {
      name: "User Manage",
      to: "/components",
      icon: "book",
      children: [
        { to: "/components/clientList", name: "List" },
        { to: "/components/clientAdd", name: "Add User" },
      ],
    };

    userDetailsRoutes = {
      name: "User Manage",
      to: "/components",
      icon: "users-cog",
      children: [
        { to: "/components/userList", name: "List" },
        { to: "/components/userAdd", name: "Add User" },
      ],
    };

    settingsRoutes = {
      name: "Settings",
      to: "/components",
      icon: "code-branch",
      children: [
        { to: "/components/clientList", name: "Reset Password" },
        { to: "/components/clientAdd", name: "Offline Video" },
      ],
    };

    componentRoutes = {
      name: "Clients",
      to: "/components",
      icon: "puzzle-piece",
      children: [
        { to: "/components/alerts", name: "Alerts" },
        { to: "/components/accordions", name: "Accordions" },
        { to: "/components/avatar", name: "Avatar" },
        { to: "/components/badges", name: "Badges" },
        { to: "/components/backgrounds", name: "Backgrounds" },
        { to: "/components/breadcrumb", name: "Breadcrumb" },
        { to: "/components/buttons", name: "Buttons" },
        { to: "/components/cards", name: "Cards" },
        { to: "/components/collapses", name: "Collapses" },
        {
          to: "/components/carousel",
          name: "Carousel",
          badge: {
            text: `New`,
          },
        },
        { to: "/components/dropdowns", name: "Dropdowns" },
        { to: "/components/forms", name: "Forms" },
        { to: "/components/listgroups", name: "List groups" },
        { to: "/components/modals", name: "Modals" },
        { to: "/components/navs", name: "Navs" },
        { to: "/components/navbars", name: "Navbars" },
        {
          to: "/components/navbar-top",
          name: "Navbar Top",
          badge: {
            text: `New`,
          },
        },
        { to: "/components/pageheaders", name: "Page headers" },
        { to: "/components/paginations", name: "Paginations" },
        { to: "/components/popovers", name: "Popovers" },
        { to: "/components/progress", name: "Progress" },
        {
          to: "/components/sidepanel",
          name: "Sidepanel",
          badge: {
            text: "New",
          },
        },
        {
          to: "/components/spinners",
          name: "Spinners",
          badge: {
            text: `New`,
          },
        },

        { to: "/components/tables", name: "Tables" },
        { to: "/components/clientList", name: "Client List" },
        { to: "/components/clientAdd", name: "Client Add" },
        { to: "/components/clientEdit", name: "Client Edit" },
        { to: "/components/tooltips", name: "Tooltips" },
      ],
    };
    pluginRoutes = {
      name: "Plugins",
      to: "/plugins",
      icon: "plug",
      children: [
        { to: "/plugins/bulk-select", name: "Bulk select" },
        {
          to: "/plugins",
          name: "Chart",
          children: [
            { to: "/plugins/chart", name: "Chart Js" },
            { to: "/plugins/echarts", name: "Echarts" },
          ],
        },
        { to: "/plugins/countup", name: "Countup" },
        { to: "/plugins/code-highlight", name: "Code Highlight" },

        { to: "/plugins/datetime", name: "Datetime" },
        { to: "/plugins/dropzone", name: "Dropzone" },
        { to: "/plugins/emoji-mart", name: "Emoji Mart" },
        { to: "/plugins/fontawesome", name: "Fontawesome" },

        { to: "/plugins/image-lightbox", name: "Image lightbox" },
        { to: "/plugins/lottie", name: "Lottie" },
        {
          to: "/plugins",
          name: "Map",
          children: [
            { to: "/plugins/leaflet-map", name: "Leaflet map" },
            { to: "/plugins/google-map", name: "Google map" },
            { to: "/plugins/echart-map", name: "Echart Map" },
          ],
        },
        { to: "/plugins/progressbar", name: "Progressbar" },
        { to: "/plugins/react-hook-form", name: "React Hook Form" },
        { to: "/plugins/select", name: "Select" },
        { to: "/plugins/slick-carousel", name: "Slick Carousel" },
        { to: "/plugins/scroll-bar", name: "Scroll Bar" },
        { to: "/plugins/toastify", name: "Toastify" },
        { to: "/plugins/typed", name: "Typed" },
        { to: "/plugins/wysiwyg", name: "WYSIWYG editor" },
      ],
    };

    utilityRoutes = {
      name: "Utilities",
      to: "/utilities",
      icon: ["fab", "hotjar"],
      children: [
        { to: "/utilities/borders", name: "Borders" },
        { to: "/utilities/clearfix", name: "Clearfix" },
        { to: "/utilities/closeIcon", name: "Close icon" },
        { to: "/utilities/colors", name: "Colors" },
        { to: "/utilities/display", name: "Display" },
        { to: "/utilities/embed", name: "Embed" },
        { to: "/utilities/figures", name: "Figures" },
        { to: "/utilities/flex", name: "Flex" },
        { to: "/utilities/grid", name: "Grid" },
        { to: "/utilities/sizing", name: "Sizing" },
        { to: "/utilities/spacing", name: "Spacing" },
        { to: "/utilities/stretchedLink", name: "Stretched link" },
        { to: "/utilities/typography", name: "Typography" },
        { to: "/utilities/verticalAlign", name: "Vertical align" },
        { to: "/utilities/visibility", name: "Visibility" },
      ],
    };
    templateroutes = {
      name: "Template",
      to: "/components",
      icon: "copy",
      children: [
        { to: "/components/templateadd", name: "Template Add" },
        { to: "/components/templatelist", name: "Template List" },
        { to: "/components/createtheme", name: "Theme Create" },
        { to: "/components/themelist", name: "Theme List" },
        (bannerroutes = {
          name: "Banner",
          to: "/components",
          icon: "copy",
          children: [
            { to: "/components/bannerupload", name: "Banner Upload" },
            { to: "/components/bannerlist", name: "Banner List" },
          ],
        }),
        (rssfeedroutes = {
          name: "RSS Feed",
          to: "/components",
          icon: "copy",
          children: [
            { to: "/components/rssfeedadd", name: "RSS Feed Add" },
            { to: "/components/rssfeedlist", name: "RSS Feed List" },
          ],
        }),
      ],
    };

     videoAnalyticsReport = {
      name: "Video Analytics Report",
      to: "/components/videoAnalyticsReport",
      icon: "poll",
    };
    doohAnalyticsReport = {
      name: "Loop Analytics Report",
      to: "/components/doohAnalyticsReport",
      icon: "list",
    };

    demographicRoutes = {
      name: "Demographic Report",
      to: "/components/demographic/report",
      icon: "chart-area",

    }

    newLocationRoutes = {
      name: "Locations",
      to: "/components",
      icon: "map-marked",
      children: [
        { to: "/components/locationList", name: "List" },
        { to: "/components/locationAdd", name: "Add New" },
      ],
    };} 
  else if (user.tenant_id === 335 && user.client_id === 117 && process.env.REACT_APP_ENVIRONMENT === "production") {
      homeRoutes = {
      name: "DASHBOARD",
      to: "/",
      exact: true,
      icon: "gauge-high",
    };
    demandAdApprovalRoutes = {
      name: "AD APPROVALS",
      to: "/components/demand/adapproval/list",
      icon: "ad",
    };
    superReportRoutes = {
      name: "ANALYTICS",
      to: "/components",
      icon: "chart-area",
      children: [
      { to: "/components/superReport", name: "Revenue" },
      ],
    };}
  else if (user.role === 1 && user.tenant_id === 335) {
      homeRoutes = {
      name: "DASHBOARD",
      to: "/",
      exact: true,
      icon: "gauge-high",
    };

    // videoRoutes = {
    //   name: "VIDEOS",
    //   to: "/components",
    //   icon: "video",
    //   children: [
    //     { to: "/videos", name: "List" },
    //   ],
    // };

    // bannerRoutes = {
    //   name: "BANNERS",
    //   to: "/components",
    //   icon: "image",
    //   children: [
    //     { to: "/banners", name: "List" },
    //   ],
    // };
    deviceRoutes = {
      name: "SCREENS",
      to: "/components",
      icon: "tv",
      children: [
        { to: "/components/deviceList", name: "List" },
        { to: "/components/deviceAdd", name: "Add New" },
        { to: "/components/device/enquiry", name: "Inquiry"},

      ],
    };

    playlistRoutes = {
      name: "PLAYLIST",
      to: "/components",
      icon: "list",
      children: [
        {to: "/playlists", name : "List"},
        { to: "/playlists/add", name: "Add New" },
      ],
    };
    doohPlaylistRoutes = {
      name: "LOOP",
      to: "/components",
      icon: "list-alt",
      children: [
        { to: "/dooh-loop/list", name : "List"},
        { to: "/dooh-loop/add", name: "Create New" },
        { to: "/components", name: "Video Library",
      children: [
        { to: "/videos", name: "List" },
      ],},
      { to: "/components", name: "Static Library",
      children: [
        { to: "/banners", name: "List" },
      ]
    },]};

    campaignRoutes = {
      name: "ADSERVER",
      to: "/components",
      icon: "bullhorn",
      children: [
        { to: "/components/campaignList", name: "List" },
        { to: "/components/campaignAdd", name: "Create New" },
        { to: "/components/advertiserList", name: "Advertiser List" },
        { to: "/components/advertiserAdd", name: "Add Advertiser" },
        // { to: "/components/ActiveList", name: " Active Campaigns" },
        //{ to: "/components/campaignReport", name: "Report" },
        // (advertiserroutes = {
        //   name: "Advertiser",
        //   to: "/components",
        //   icon: "lock",
        //   children: [
        //     {
        //       to: "/components/CampaignPaymentAdmn",
        //       name: "Advertiser Payment",
        //     },
        //     {
        //       to: "/components/advertiserstatement",
        //       name: "Advertiser Statement",
        //     },
        //     { to: "/components/paymentReport", name: "Payment Details" },
        //   ],
        // }),
      ],
    };

    adApprovalRoutes = {
      name: "AD CONFIRMATION",
      to: "/components",
      icon: "ad",
      children: [
        { to: "/components/pendingList", name: "Pending" },
        { to: "/components/approvedList", name: "Approved" },
        { to: "/components/rejectedList", name: "Declined Ads" },
        { to: "/components/AllAdList", name: "All Ads" },
      ],
    };

    demandAdApprovalRoutes = {
      name: "AD APPROVALS",
      to: "/components/demand/adapproval/list",
      icon: "ad",
    };

    creativeManagementRoutes = {
      name :"CREATIVE LIBRARY",
      to : "/components",
      icon : "photo-film",
      children : [
        {to : "/components/creativeManageList", name : "List"},
        {to : "/components/creativeManageAdd", name : "Add New"},
      ],
    }


    userNameRoutes = {
      name: "NETWORKS",
      to: "/components",
      icon: "mountain-city",
      children: [
        { to: "/components/userNameList", name: "List" },
        { to: "/components/userNameAdd", name: "Add New" },
      ],
    };

    locationRoutes = {
      name: "VENUES",
      to: "/components",
      icon: "shop",
      children: [
        { to: "/components/locationList", name: "List" },
        { to: "/components/locationAdd", name: "Add New" },
      ],
    };

    userManagementRoutes = {
      name: "User Manage",
      to: "/components",
      icon: "book",
      children: [
        { to: "/components/clientList", name: "List" },
        { to: "/components/clientAdd", name: "Add User" },
      ],
    };

    userDetailsRoutes = {
      name: "User Manage",
      to: "/components",
      icon: "users-cog",
      children: [
        { to: "/components/userList", name: "List" },
        { to: "/components/userAdd", name: "Add User" },
      ],
    };
    display = {
      name: "Banner Campaigns",
      to: "/components",
      icon: "image",
      children: [
        (displayCampaignRoutes = {
          name: "Campaign Manage",
          to: "/components",
          children: [
            { to: "/components/displayCampaignList", name: "List" },
            { to: "/components/displayCampaign/Report", name: "Report" },
          ],
        }),
      ],
    };
    superReportRoutes = {
      name: "ANALYTICS",
      to: "/components",
      icon: "chart-area",
      children: [
      //{ to: "/components/videoAnalyticsReport", name: "Video Analytics Report", icon: "poll", },
      { to: "/components/doohAnalyticsReport", name: "LOOP Playback Report" },
      ],
    };
    }
 else if (user.role === 1) {
    homeRoutes = {
      name: "Home",
      to: "/",
      exact: true,
      icon: "home",
      children: [
        {
          to: "/",
          name: "Dashboard",
          icon: "chart-pie",
          exact: true,
        },
      ],
    };

    videoRoutes = {
      name: "Videos",
      to: "/components",
      icon: "video",
      children: [
        { to: "/videos", name: "List" },
      ],
    };

    bannerRoutes = {
      name: "Banner",
      to: "/components",
      icon: "image",
      children: [
        { to: "/banners", name: "List" },
      ],
    };
    deviceRoutes = {
      name: "Devices",
      to: "/components",
      icon: "tv",
      children: [
        { to: "/components/deviceList", name: "List" },
        { to: "/components/deviceAdd", name: "Add New" },
        { to: "/components/device/enquiry", name: "Inquiry"},

      ],
    };

    playlistRoutes = {
      name: "Playlist",
      to: "/components",
      icon: "list",
      children: [
        {to: "/playlists/", name : "List"},
        { to: "/playlists/add", name: "Add New" },
      ],
    };

    doohPlaylistRoutes = {
      name: "DOOH Loop",
      to: "/components",
      icon: "list-alt",
      children: [
        {to: "/dooh-loop/list", name : "List"},
        { to: "/dooh-loop/add", name: "Add" },
      ],
    }

    campaignRoutes = {
      name: "Video Campaigns",
      to: "/components",
      icon: "play",
      children: [
        { to: "/components/campaignList", name: "List" },
        { to: "/components/ActiveList", name: " Active List" },
        { to: "/components/campaignReport", name: "Report" },
        // { to: "/components/campaignReport/new", name: "Report New" },
        (advertiserroutes = {
          name: "Advertiser",
          to: "/components",
          icon: "lock",
          children: [
            {
              to: "/components/CampaignPaymentAdmn",
              name: "Advertiser Payment",
            },
            {
              to: "/components/advertiserstatement",
              name: "Advertiser Statement",
            },
            { to: "/components/paymentReport", name: "Payment Details" },
          ],
        }),
      ],
    };

    adApprovalRoutes = {
      name: "Ad Confirmation",
      to: "/components",
      icon: "ad",
      children: [
        { to: "/components/pendingList", name: "Pending" },
        { to: "/components/approvedList", name: "Approved" },
        { to: "/components/rejectedList", name: "Declined Ads" },
        { to: "/components/AllAdList", name: "All Ads" },
      ],
    };

    demandAdApprovalRoutes = {
      name: "Demand Ad Confirmation",
      to: "/components/demand/adapproval/list",
      icon: "ad",
    };

    creativeManagementRoutes = {
      name :"Creative Management",
      to : "/components",
      icon : "photo-video",
      children : [
        {to : "/components/creativeManageList", name : "List"},
        {to : "/components/creativeManageAdd", name : "Add New"},
      ],
    }

    superReportRoutes = {
      name: "Revenue Report",
      to: "/components/superReport",
      icon: "user-tie",
    };

    outagereportroutes = {
      name: "Outage Report",
      to: "/components/outagereport",
      icon: "lock",
    };
    merchantRoutes = {
      name: "Merchant Statement",
      to: "/components/merchantStatement",
      icon: "copy",
    };

    monthlyRoutes = {
      name: "Monthly Statement",
      to: "/components/monthlyStatement",
      icon: "copy",
    };

    userNameRoutes = {
      name: "Networks",
      to: "/components",
      icon: "cubes",
      children: [
        { to: "/components/userNameList", name: "List" },
        { to: "/components/userNameAdd", name: "Add New" },
      ],
    };

    userManagementRoutes = {
      name: "User Manage",
      to: "/components",
      icon: "book",
      children: [
        { to: "/components/clientList", name: "List" },
        { to: "/components/clientAdd", name: "Add User" },
      ],
    };

    userDetailsRoutes = {
      name: "User Manage",
      to: "/components",
      icon: "users-cog",
      children: [
        { to: "/components/userList", name: "List" },
        { to: "/components/userAdd", name: "Add User" },
      ],
    };

    settingsRoutes = {
      name: "Settings",
      to: "/components",
      icon: "code-branch",
      children: [
        { to: "/components/clientList", name: "Reset Password" },
        { to: "/components/clientAdd", name: "Offline Video" },
      ],
    };

    authenticationRoutes = {
      name: "Authentication",
      to: "/authentication",
      icon: "lock",
      children: [
        {
          to: "/authentication/basic",
          name: "Basic",
          children: [
            { to: "/authentication/basic/login", name: "Login" },
            { to: "/authentication/basic/logout", name: "Logout" },
            { to: "/authentication/basic/register", name: "Register" },
            {
              to: "/authentication/basic/forget-password",
              name: "Forgot password",
            },
            {
              to: "/authentication/basic/password-reset",
              name: "Reset password",
            },
            { to: "/authentication/basic/confirm-mail", name: "Confirm mail" },
            { to: "/authentication/basic/lock-screen", name: "Lock screen" },
          ],
        },
        {
          to: "/authentication/card",
          name: "Card",
          children: [
            { to: "/authentication/card/login", name: "Login" },
            { to: "/authentication/card/logout", name: "Logout" },
            { to: "/authentication/card/register", name: "Register" },
            {
              to: "/authentication/card/forget-password",
              name: "Forgot password",
            },
            {
              to: "/authentication/card/password-reset",
              name: "Reset password",
            },
            { to: "/authentication/card/confirm-mail", name: "Confirm mail" },
            { to: "/authentication/card/lock-screen", name: "Lock screen" },
          ],
        },
        {
          to: "/authentication/split",
          name: "Split",
          children: [
            { to: "/authentication/split/login", name: "Login" },
            { to: "/authentication/split/logout", name: "Logout" },
            { to: "/authentication/split/register", name: "Register" },
            {
              to: "/authentication/split/forget-password",
              name: "Forgot password",
            },
            {
              to: "/authentication/split/password-reset",
              name: "Reset password",
            },
            { to: "/authentication/split/confirm-mail", name: "Confirm mail" },
            { to: "/authentication/split/lock-screen", name: "Lock screen" },
          ],
        },
        {
          to: "/authentication/wizard",
          name: "Wizard",
        },
      ],
    };

    ECommerceRoutes = {
      name: "E commerce",
      to: "/e-commerce",
      icon: "cart-plus",
      children: [
        { to: "/e-commerce/products/list", name: "Product list" },
        { to: "/e-commerce/products/grid", name: "Product grid" },
        { to: "/e-commerce/product-details", name: "Product details" },
        { to: "/e-commerce/orders", name: "Orders" },
        { to: "/e-commerce/order-details", name: "Order details" },
        { to: "/e-commerce/customers", name: "Customers" },
        { to: "/e-commerce/shopping-cart", name: "Shopping cart" },
        { to: "/e-commerce/checkout", name: "Checkout" },
        { to: "/e-commerce/favourite-items", name: "Favourite items" },
      ],
    };

    pageRoutes = {
      name: "Pages",
      to: "/pages",
      icon: "copy",
      children: [
        { to: "/pages/activity", name: "Activity" },
        { to: "/pages/associations", name: "Associations" },
        { to: "/pages/billing", name: "Billing" },
        { to: "/pages/customer-details", name: "Customer details" },
        { to: "/pages/event-detail", name: "Event detail" },
        { to: "/pages/event-create", name: "Event create" },
        { to: "/pages/events", name: "Events" },
        { to: "/pages/faq", name: "Faq" },
        { to: "/pages/invoice", name: "Invoice" },
        { to: "/pages/invite-people", name: "Invite people" },
        { to: "/pages/notifications", name: "Notifications" },
        { to: "/pages/people", name: "People" },
        { to: "/pages/pricing", name: "Pricing" },
        { to: "/pages/pricing-alt", name: "Pricing alt" },
        { to: "/pages/profile", name: "Profile" },
        { to: "/pages/settings", name: "Settings" },
        { to: "/pages/starter", name: "Starter" },
        {
          to: "/errors",
          name: "Errors",
          children: [
            { to: "/errors/404", name: "404" },
            { to: "/errors/500", name: "500" },
          ],
        },
      ],
    };
    widgetsRoutes = {
      name: "Widgets",
      to: "/widgets",
      exact: true,
      icon: "poll",
      badge: {
        text: `New`,
        color: "soft-success",
      },
    };

    chatRoutes = {
      name: "Chat",
      to: "/chat",
      exact: true,
      icon: "comments",
    };

    emailRoutes = {
      name: "Email",
      to: "/email",
      icon: "envelope-open",
      children: [
        { to: "/email/inbox", name: "Inbox" },
        { to: "/email/email-detail", name: "Email detail" },
        { to: "/email/compose", name: "Compose" },
      ],
    };

    documentationRoutes = {
      name: "Documentation",
      to: "/documentation",
      exact: true,
      icon: "book",
    };

    changelogRoutes = {
      name: "ChangeLog",
      to: "/changelog",
      exact: true,
      icon: "code-branch",
      badge: {
        text: `v${version}`,
        color: "soft-primary",
      },
    };

    componentRoutes = {
      name: "Clients",
      to: "/components",
      icon: "puzzle-piece",
      children: [
        { to: "/components/alerts", name: "Alerts" },
        { to: "/components/accordions", name: "Accordions" },
        { to: "/components/avatar", name: "Avatar" },
        { to: "/components/badges", name: "Badges" },
        { to: "/components/backgrounds", name: "Backgrounds" },
        { to: "/components/breadcrumb", name: "Breadcrumb" },
        { to: "/components/buttons", name: "Buttons" },
        { to: "/components/cards", name: "Cards" },
        { to: "/components/collapses", name: "Collapses" },
        {
          to: "/components/carousel",
          name: "Carousel",
          badge: {
            text: `New`,
          },
        },
        { to: "/components/dropdowns", name: "Dropdowns" },
        { to: "/components/forms", name: "Forms" },
        { to: "/components/listgroups", name: "List groups" },
        { to: "/components/modals", name: "Modals" },
        { to: "/components/navs", name: "Navs" },
        { to: "/components/navbars", name: "Navbars" },
        {
          to: "/components/navbar-top",
          name: "Navbar Top",
          badge: {
            text: `New`,
          },
        },
        { to: "/components/pageheaders", name: "Page headers" },
        { to: "/components/paginations", name: "Paginations" },
        { to: "/components/popovers", name: "Popovers" },
        { to: "/components/progress", name: "Progress" },
        {
          to: "/components/sidepanel",
          name: "Sidepanel",
          badge: {
            text: "New",
          },
        },
        {
          to: "/components/spinners",
          name: "Spinners",
          badge: {
            text: `New`,
          },
        },

        { to: "/components/tables", name: "Tables" },
        { to: "/components/clientList", name: "Client List" },
        { to: "/components/clientAdd", name: "Client Add" },
        { to: "/components/clientEdit", name: "Client Edit" },
        { to: "/components/tooltips", name: "Tooltips" },
      ],
    };
    pluginRoutes = {
      name: "Plugins",
      to: "/plugins",
      icon: "plug",
      children: [
        { to: "/plugins/bulk-select", name: "Bulk select" },
        {
          to: "/plugins",
          name: "Chart",
          children: [
            { to: "/plugins/chart", name: "Chart Js" },
            { to: "/plugins/echarts", name: "Echarts" },
          ],
        },
        { to: "/plugins/countup", name: "Countup" },
        { to: "/plugins/code-highlight", name: "Code Highlight" },

        { to: "/plugins/datetime", name: "Datetime" },
        { to: "/plugins/dropzone", name: "Dropzone" },
        { to: "/plugins/emoji-mart", name: "Emoji Mart" },
        { to: "/plugins/fontawesome", name: "Fontawesome" },

        { to: "/plugins/image-lightbox", name: "Image lightbox" },
        { to: "/plugins/lottie", name: "Lottie" },
        {
          to: "/plugins",
          name: "Map",
          children: [
            { to: "/plugins/leaflet-map", name: "Leaflet map" },
            { to: "/plugins/google-map", name: "Google map" },
            { to: "/plugins/echart-map", name: "Echart Map" },
          ],
        },
        { to: "/plugins/progressbar", name: "Progressbar" },
        { to: "/plugins/react-hook-form", name: "React Hook Form" },
        { to: "/plugins/select", name: "Select" },
        { to: "/plugins/slick-carousel", name: "Slick Carousel" },
        { to: "/plugins/scroll-bar", name: "Scroll Bar" },
        { to: "/plugins/toastify", name: "Toastify" },
        { to: "/plugins/typed", name: "Typed" },
        { to: "/plugins/wysiwyg", name: "WYSIWYG editor" },
      ],
    };

    utilityRoutes = {
      name: "Utilities",
      to: "/utilities",
      icon: ["fab", "hotjar"],
      children: [
        { to: "/utilities/borders", name: "Borders" },
        { to: "/utilities/clearfix", name: "Clearfix" },
        { to: "/utilities/closeIcon", name: "Close icon" },
        { to: "/utilities/colors", name: "Colors" },
        { to: "/utilities/display", name: "Display" },
        { to: "/utilities/embed", name: "Embed" },
        { to: "/utilities/figures", name: "Figures" },
        { to: "/utilities/flex", name: "Flex" },
        { to: "/utilities/grid", name: "Grid" },
        { to: "/utilities/sizing", name: "Sizing" },
        { to: "/utilities/spacing", name: "Spacing" },
        { to: "/utilities/stretchedLink", name: "Stretched link" },
        { to: "/utilities/typography", name: "Typography" },
        { to: "/utilities/verticalAlign", name: "Vertical align" },
        { to: "/utilities/visibility", name: "Visibility" },
      ],
    };
    display = {
      name: "Banner Campaigns",
      to: "/components",
      icon: "image",
      children: [
        (displayCampaignRoutes = {
          name: "Campaign Manage",
          to: "/components",
          icon: "play",
          children: [
            { to: "/components/displayCampaignList", name: "List" },
            { to: "/components/displayCampaign/Report", name: "Report" },
          ],
        }),
      ],
    };
    videoAnalyticsReport = {
      name: "Video Analytics Report",
      to: "/components/videoAnalyticsReport",
      icon: "poll",
    };
    doohAnalyticsReport = {
      name: "Loop Analytics Report",
      to: "/components/doohAnalyticsReport",
      icon: "list",
    };

    newLocationRoutes = {
      name: "Locations",
      to: "/components",
      icon: "map-marked",
      children: [
        { to: "/components/locationList", name: "List" },
        { to: "/components/locationAdd", name: "Add New" },
      ],
    };
  } else if (user.role === 10) {
    homeRoutes = {
      name: "Home",
      to: "/",
      exact: true,
      icon: "home",
      children: [
        {
          to: "/",
          name: "Dashboard",
          icon: "chart-pie",
          exact: true,
        },
      ],
    };

    videoRoutes = {
      name: "Videos",
      to: "/components",
      icon: "video",
      children: [
        { to: "/videos", name: "List" },
      ],
    };

    bannerRoutes = {
      name: "Banner",
      to: "/components",
      icon: "image",
      children: [
        { to: "/banners", name: "List" },
      ],
    };
    deviceRoutes = {
      name: "Devices",
      to: "/components",
      icon: "tv",
      children: [
        { to: "/components/deviceList", name: "List" },
        { to: "/components/deviceAdd", name: "Add New" },
        { to: "/components/device/enquiry", name: "Inquiry"},

      ],
    };

    playlistRoutes = {
      name: "Playlist",
      to: "/components",
      icon: "list",
      children: [
        {to: "/playlists/", name : "List"},
        { to: "/playlists/add", name: "Add New" },
      ],
    };

    doohPlaylistRoutes = {
      name: "DOOH Loop",
      to: "/components",
      icon: "list-alt",
      children: [
        {to: "/dooh-loop/list", name : "List"},
        { to: "/dooh-loop/add", name: "Add" },
      ],
    };
    
    campaignRoutes = {
      name: "Video Campaigns",
      to: "/components",
      icon: "play",
      children: [
        { to: "/components/campaignList", name: "List" },
  
      ],
    };

    superReportRoutes = {
      name: "Report",
      to: "/components/superReport",
      icon: "user-tie",
    };

    outagereportroutes = {
      name: "Outage Report",
      to: "/components/outagereport",
      icon: "lock",
    };

    monthlyRoutes = {
      name: "Monthly Statement",
      to: "/components/monthlyStatement",
      icon: "copy",
    };

    userManagementRoutes = {
      name: "User Manage",
      to: "/components",
      icon: "book",
      children: [
        { to: "/components/clientList", name: "List" },
        { to: "/components/clientAdd", name: "Add User" },
      ],
    };

    userDetailsRoutes = {
      name: "User Manage",
      to: "/components",
      icon: "users-cog",
      children: [
        { to: "/components/userList", name: "List" },
        { to: "/components/userAdd", name: "Add User" },
      ],
    };

    adApprovalRoutes = {
      name: "Ad Confirmation",
      to: "/components",
      icon: "ad",
      children: [
        { to: "/components/pendingList", name: "Pending" },
        { to: "/components/approvedList", name: "Approved" },
        { to: "/components/rejectedList", name: "Declined Ads" },
        { to: "/components/AllAdList", name: "All Ads" },
      ],
    };

    settingsRoutes = {
      name: "Settings",
      to: "/components",
      icon: "code-branch",
      children: [
        { to: "/components/clientList", name: "Reset Password" },
        { to: "/components/clientAdd", name: "Offline Video" },
      ],
    };

    importRoutes = {
      name: "Import Data",
      to: "/components/clientList",
      icon: "lock",
    };

    authenticationRoutes = {
      name: "Authentication",
      to: "/authentication",
      icon: "lock",
      children: [
        {
          to: "/authentication/basic",
          name: "Basic",
          children: [
            { to: "/authentication/basic/login", name: "Login" },
            { to: "/authentication/basic/logout", name: "Logout" },
            { to: "/authentication/basic/register", name: "Register" },
            {
              to: "/authentication/basic/forget-password",
              name: "Forgot password",
            },
            {
              to: "/authentication/basic/password-reset",
              name: "Reset password",
            },
            { to: "/authentication/basic/confirm-mail", name: "Confirm mail" },
            { to: "/authentication/basic/lock-screen", name: "Lock screen" },
          ],
        },
        {
          to: "/authentication/card",
          name: "Card",
          children: [
            { to: "/authentication/card/login", name: "Login" },
            { to: "/authentication/card/logout", name: "Logout" },
            { to: "/authentication/card/register", name: "Register" },
            {
              to: "/authentication/card/forget-password",
              name: "Forgot password",
            },
            {
              to: "/authentication/card/password-reset",
              name: "Reset password",
            },
            { to: "/authentication/card/confirm-mail", name: "Confirm mail" },
            { to: "/authentication/card/lock-screen", name: "Lock screen" },
          ],
        },
        {
          to: "/authentication/split",
          name: "Split",
          children: [
            { to: "/authentication/split/login", name: "Login" },
            { to: "/authentication/split/logout", name: "Logout" },
            { to: "/authentication/split/register", name: "Register" },
            {
              to: "/authentication/split/forget-password",
              name: "Forgot password",
            },
            {
              to: "/authentication/split/password-reset",
              name: "Reset password",
            },
            { to: "/authentication/split/confirm-mail", name: "Confirm mail" },
            { to: "/authentication/split/lock-screen", name: "Lock screen" },
          ],
        },
        {
          to: "/authentication/wizard",
          name: "Wizard",
        },
      ],
    };

    ECommerceRoutes = {
      name: "E commerce",
      to: "/e-commerce",
      icon: "cart-plus",
      children: [
        { to: "/e-commerce/products/list", name: "Product list" },
        { to: "/e-commerce/products/grid", name: "Product grid" },
        { to: "/e-commerce/product-details", name: "Product details" },
        { to: "/e-commerce/orders", name: "Orders" },
        { to: "/e-commerce/order-details", name: "Order details" },
        { to: "/e-commerce/customers", name: "Customers" },
        { to: "/e-commerce/shopping-cart", name: "Shopping cart" },
        { to: "/e-commerce/checkout", name: "Checkout" },
        { to: "/e-commerce/favourite-items", name: "Favourite items" },
      ],
    };

    pageRoutes = {
      name: "Pages",
      to: "/pages",
      icon: "copy",
      children: [
        { to: "/pages/activity", name: "Activity" },
        { to: "/pages/associations", name: "Associations" },
        { to: "/pages/billing", name: "Billing" },
        { to: "/pages/customer-details", name: "Customer details" },
        { to: "/pages/event-detail", name: "Event detail" },
        { to: "/pages/event-create", name: "Event create" },
        { to: "/pages/events", name: "Events" },
        { to: "/pages/faq", name: "Faq" },
        { to: "/pages/invoice", name: "Invoice" },
        { to: "/pages/invite-people", name: "Invite people" },
        { to: "/pages/notifications", name: "Notifications" },
        { to: "/pages/people", name: "People" },
        { to: "/pages/pricing", name: "Pricing" },
        { to: "/pages/pricing-alt", name: "Pricing alt" },
        { to: "/pages/profile", name: "Profile" },
        { to: "/pages/settings", name: "Settings" },
        { to: "/pages/starter", name: "Starter" },
        {
          to: "/errors",
          name: "Errors",
          children: [
            { to: "/errors/404", name: "404" },
            { to: "/errors/500", name: "500" },
          ],
        },
      ],
    };
    widgetsRoutes = {
      name: "Widgets",
      to: "/widgets",
      exact: true,
      icon: "poll",
      badge: {
        text: `New`,
        color: "soft-success",
      },
    };

    chatRoutes = {
      name: "Chat",
      to: "/chat",
      exact: true,
      icon: "comments",
    };

    emailRoutes = {
      name: "Email",
      to: "/email",
      icon: "envelope-open",
      children: [
        { to: "/email/inbox", name: "Inbox" },
        { to: "/email/email-detail", name: "Email detail" },
        { to: "/email/compose", name: "Compose" },
      ],
    };

    documentationRoutes = {
      name: "Documentation",
      to: "/documentation",
      exact: true,
      icon: "book",
    };

    changelogRoutes = {
      name: "ChangeLog",
      to: "/changelog",
      exact: true,
      icon: "code-branch",
      badge: {
        text: `v${version}`,
        color: "soft-primary",
      },
    };

    componentRoutes = {
      name: "Clients",
      to: "/components",
      icon: "puzzle-piece",
      children: [
        { to: "/components/alerts", name: "Alerts" },
        { to: "/components/accordions", name: "Accordions" },
        { to: "/components/avatar", name: "Avatar" },
        { to: "/components/badges", name: "Badges" },
        { to: "/components/backgrounds", name: "Backgrounds" },
        { to: "/components/breadcrumb", name: "Breadcrumb" },
        { to: "/components/buttons", name: "Buttons" },
        { to: "/components/cards", name: "Cards" },
        { to: "/components/collapses", name: "Collapses" },
        {
          to: "/components/carousel",
          name: "Carousel",
          badge: {
            text: `New`,
          },
        },
        { to: "/components/dropdowns", name: "Dropdowns" },
        { to: "/components/forms", name: "Forms" },
        { to: "/components/listgroups", name: "List groups" },
        { to: "/components/modals", name: "Modals" },
        { to: "/components/navs", name: "Navs" },
        { to: "/components/navbars", name: "Navbars" },
        {
          to: "/components/navbar-top",
          name: "Navbar Top",
          badge: {
            text: `New`,
          },
        },
        { to: "/components/pageheaders", name: "Page headers" },
        { to: "/components/paginations", name: "Paginations" },
        { to: "/components/popovers", name: "Popovers" },
        { to: "/components/progress", name: "Progress" },
        {
          to: "/components/sidepanel",
          name: "Sidepanel",
          badge: {
            text: "New",
          },
        },
        {
          to: "/components/spinners",
          name: "Spinners",
          badge: {
            text: `New`,
          },
        },

        { to: "/components/tables", name: "Tables" },
        { to: "/components/clientList", name: "Client List" },
        { to: "/components/clientAdd", name: "Client Add" },
        { to: "/components/clientEdit", name: "Client Edit" },
        { to: "/components/tooltips", name: "Tooltips" },
      ],
    };
    pluginRoutes = {
      name: "Plugins",
      to: "/plugins",
      icon: "plug",
      children: [
        { to: "/plugins/bulk-select", name: "Bulk select" },
        {
          to: "/plugins",
          name: "Chart",
          children: [
            { to: "/plugins/chart", name: "Chart Js" },
            { to: "/plugins/echarts", name: "Echarts" },
          ],
        },
        { to: "/plugins/countup", name: "Countup" },
        { to: "/plugins/code-highlight", name: "Code Highlight" },

        { to: "/plugins/datetime", name: "Datetime" },
        { to: "/plugins/dropzone", name: "Dropzone" },
        { to: "/plugins/emoji-mart", name: "Emoji Mart" },
        { to: "/plugins/fontawesome", name: "Fontawesome" },

        { to: "/plugins/image-lightbox", name: "Image lightbox" },
        { to: "/plugins/lottie", name: "Lottie" },
        {
          to: "/plugins",
          name: "Map",
          children: [
            { to: "/plugins/leaflet-map", name: "Leaflet map" },
            { to: "/plugins/google-map", name: "Google map" },
            { to: "/plugins/echart-map", name: "Echart Map" },
          ],
        },
        { to: "/plugins/progressbar", name: "Progressbar" },
        { to: "/plugins/react-hook-form", name: "React Hook Form" },
        { to: "/plugins/select", name: "Select" },
        { to: "/plugins/slick-carousel", name: "Slick Carousel" },
        { to: "/plugins/scroll-bar", name: "Scroll Bar" },
        { to: "/plugins/toastify", name: "Toastify" },
        { to: "/plugins/typed", name: "Typed" },
        { to: "/plugins/wysiwyg", name: "WYSIWYG editor" },
      ],
    };

    utilityRoutes = {
      name: "Utilities",
      to: "/utilities",
      icon: ["fab", "hotjar"],
      children: [
        { to: "/utilities/borders", name: "Borders" },
        { to: "/utilities/clearfix", name: "Clearfix" },
        { to: "/utilities/closeIcon", name: "Close icon" },
        { to: "/utilities/colors", name: "Colors" },
        { to: "/utilities/display", name: "Display" },
        { to: "/utilities/embed", name: "Embed" },
        { to: "/utilities/figures", name: "Figures" },
        { to: "/utilities/flex", name: "Flex" },
        { to: "/utilities/grid", name: "Grid" },
        { to: "/utilities/sizing", name: "Sizing" },
        { to: "/utilities/spacing", name: "Spacing" },
        { to: "/utilities/stretchedLink", name: "Stretched link" },
        { to: "/utilities/typography", name: "Typography" },
        { to: "/utilities/verticalAlign", name: "Vertical align" },
        { to: "/utilities/visibility", name: "Visibility" },
      ],
    };
    videoAnalyticsReport = {
      name: "Video Analytics Report",
      to: "/components/videoAnalyticsReport",
      icon: "poll",
    };
    doohAnalyticsReport = {
      name: "Loop Analytics Report",
      to: "/components/doohAnalyticsReport",
      icon: "list",
    };
    newLocationRoutes = {
      name: "Locations",
      to: "/components",
      icon: "map-marked",
      children: [
        { to: "/components/locationList", name: "List" },
        { to: "/components/locationAdd", name: "Add New" },
      ],
    };
  } else if (user.role === 12) {
    homeRoutes = {
      name: "Home",
      to: "/",
      exact: true,
      icon: "home",
      children: [
        {
          to: "/",
          name: "Dashboard",
          icon: "chart-pie",
          exact: true,
        },
      ],
    };

    videoRoutes = {
      name: "Videos",
      to: "/components",
      icon: "video",
      children: [
        { to: "/videos", name: "List" },
      ],
    };
    bannerRoutes = {
      name: "Banner",
      to: "/components",
      icon: "image",
      children: [
        { to: "/banners", name: "List" },
      ],
    };

    deviceRoutes = {
      name: "Devices",
      to: "/components",
      icon: "tv",
      children: [
        { to: "/components/deviceList", name: "List" },
        { to: "/components/deviceAdd", name: "Add New" },
        { to: "/components/device/enquiry", name: "Inquiry"},

      ],
    };

    playlistRoutes = {
      name: "Playlist",
      to: "/components",
      icon: "list",
      children: [
        { to: "/playlists", name: "List" },
        { to: "/playlists/add", name: "Add New" },
      ],
    };

    doohPlaylistRoutes = {
      name: "DOOH Loop",
      to: "/components",
      icon: "list-alt",
      children: [
        {to: "/dooh-loop/list", name : "List"},
        { to: "/dooh-loop/add", name: "Add" },
      ],
    };

    superReportRoutes = {
      name: "Location Report",
      to: "/components/superReport",
      icon: "user-tie",
    };

    authenticationRoutes = {
      name: "Authentication",
      to: "/authentication",
      icon: "lock",
      children: [
        {
          to: "/authentication/basic",
          name: "Basic",
          children: [
            { to: "/authentication/basic/login", name: "Login" },
            { to: "/authentication/basic/logout", name: "Logout" },
            { to: "/authentication/basic/register", name: "Register" },
            {
              to: "/authentication/basic/forget-password",
              name: "Forgot password",
            },
            {
              to: "/authentication/basic/password-reset",
              name: "Reset password",
            },
            { to: "/authentication/basic/confirm-mail", name: "Confirm mail" },
            { to: "/authentication/basic/lock-screen", name: "Lock screen" },
          ],
        },
        {
          to: "/authentication/card",
          name: "Card",
          children: [
            { to: "/authentication/card/login", name: "Login" },
            { to: "/authentication/card/logout", name: "Logout" },
            { to: "/authentication/card/register", name: "Register" },
            {
              to: "/authentication/card/forget-password",
              name: "Forgot password",
            },
            {
              to: "/authentication/card/password-reset",
              name: "Reset password",
            },
            { to: "/authentication/card/confirm-mail", name: "Confirm mail" },
            { to: "/authentication/card/lock-screen", name: "Lock screen" },
          ],
        },
        {
          to: "/authentication/split",
          name: "Split",
          children: [
            { to: "/authentication/split/login", name: "Login" },
            { to: "/authentication/split/logout", name: "Logout" },
            { to: "/authentication/split/register", name: "Register" },
            {
              to: "/authentication/split/forget-password",
              name: "Forgot password",
            },
            {
              to: "/authentication/split/password-reset",
              name: "Reset password",
            },
            { to: "/authentication/split/confirm-mail", name: "Confirm mail" },
            { to: "/authentication/split/lock-screen", name: "Lock screen" },
          ],
        },
        {
          to: "/authentication/wizard",
          name: "Wizard",
        },
      ],
    };

    ECommerceRoutes = {
      name: "E commerce",
      to: "/e-commerce",
      icon: "cart-plus",
      children: [
        { to: "/e-commerce/products/list", name: "Product list" },
        { to: "/e-commerce/products/grid", name: "Product grid" },
        { to: "/e-commerce/product-details", name: "Product details" },
        { to: "/e-commerce/orders", name: "Orders" },
        { to: "/e-commerce/order-details", name: "Order details" },
        { to: "/e-commerce/customers", name: "Customers" },
        { to: "/e-commerce/shopping-cart", name: "Shopping cart" },
        { to: "/e-commerce/checkout", name: "Checkout" },
        { to: "/e-commerce/favourite-items", name: "Favourite items" },
      ],
    };

    pageRoutes = {
      name: "Pages",
      to: "/pages",
      icon: "copy",
      children: [
        { to: "/pages/activity", name: "Activity" },
        { to: "/pages/associations", name: "Associations" },
        { to: "/pages/billing", name: "Billing" },
        { to: "/pages/customer-details", name: "Customer details" },
        { to: "/pages/event-detail", name: "Event detail" },
        { to: "/pages/event-create", name: "Event create" },
        { to: "/pages/events", name: "Events" },
        { to: "/pages/faq", name: "Faq" },
        { to: "/pages/invoice", name: "Invoice" },
        { to: "/pages/invite-people", name: "Invite people" },
        { to: "/pages/notifications", name: "Notifications" },
        { to: "/pages/people", name: "People" },
        { to: "/pages/pricing", name: "Pricing" },
        { to: "/pages/pricing-alt", name: "Pricing alt" },
        { to: "/pages/profile", name: "Profile" },
        { to: "/pages/settings", name: "Settings" },
        { to: "/pages/starter", name: "Starter" },
        {
          to: "/errors",
          name: "Errors",
          children: [
            { to: "/errors/404", name: "404" },
            { to: "/errors/500", name: "500" },
          ],
        },
      ],
    };
    widgetsRoutes = {
      name: "Widgets",
      to: "/widgets",
      exact: true,
      icon: "poll",
      badge: {
        text: `New`,
        color: "soft-success",
      },
    };

    chatRoutes = {
      name: "Chat",
      to: "/chat",
      exact: true,
      icon: "comments",
    };

    emailRoutes = {
      name: "Email",
      to: "/email",
      icon: "envelope-open",
      children: [
        { to: "/email/inbox", name: "Inbox" },
        { to: "/email/email-detail", name: "Email detail" },
        { to: "/email/compose", name: "Compose" },
      ],
    };

    documentationRoutes = {
      name: "Documentation",
      to: "/documentation",
      exact: true,
      icon: "book",
    };

    changelogRoutes = {
      name: "ChangeLog",
      to: "/changelog",
      exact: true,
      icon: "code-branch",
      badge: {
        text: `v${version}`,
        color: "soft-primary",
      },
    };

    componentRoutes = {
      name: "Clients",
      to: "/components",
      icon: "puzzle-piece",
      children: [
        { to: "/components/alerts", name: "Alerts" },
        { to: "/components/accordions", name: "Accordions" },
        { to: "/components/avatar", name: "Avatar" },
        { to: "/components/badges", name: "Badges" },
        { to: "/components/backgrounds", name: "Backgrounds" },
        { to: "/components/breadcrumb", name: "Breadcrumb" },
        { to: "/components/buttons", name: "Buttons" },
        { to: "/components/cards", name: "Cards" },
        { to: "/components/collapses", name: "Collapses" },
        {
          to: "/components/carousel",
          name: "Carousel",
          badge: {
            text: `New`,
          },
        },
        { to: "/components/dropdowns", name: "Dropdowns" },
        { to: "/components/forms", name: "Forms" },
        { to: "/components/listgroups", name: "List groups" },
        { to: "/components/modals", name: "Modals" },
        { to: "/components/navs", name: "Navs" },
        { to: "/components/navbars", name: "Navbars" },
        {
          to: "/components/navbar-top",
          name: "Navbar Top",
          badge: {
            text: `New`,
          },
        },
        { to: "/components/pageheaders", name: "Page headers" },
        { to: "/components/paginations", name: "Paginations" },
        { to: "/components/popovers", name: "Popovers" },
        { to: "/components/progress", name: "Progress" },
        {
          to: "/components/sidepanel",
          name: "Sidepanel",
          badge: {
            text: "New",
          },
        },
        {
          to: "/components/spinners",
          name: "Spinners",
          badge: {
            text: `New`,
          },
        },

        { to: "/components/tables", name: "Tables" },
        { to: "/components/clientList", name: "Client List" },
        { to: "/components/clientAdd", name: "Client Add" },
        { to: "/components/clientEdit", name: "Client Edit" },
        { to: "/components/tooltips", name: "Tooltips" },
      ],
    };
    pluginRoutes = {
      name: "Plugins",
      to: "/plugins",
      icon: "plug",
      children: [
        { to: "/plugins/bulk-select", name: "Bulk select" },
        {
          to: "/plugins",
          name: "Chart",
          children: [
            { to: "/plugins/chart", name: "Chart Js" },
            { to: "/plugins/echarts", name: "Echarts" },
          ],
        },
        { to: "/plugins/countup", name: "Countup" },
        { to: "/plugins/code-highlight", name: "Code Highlight" },

        { to: "/plugins/datetime", name: "Datetime" },
        { to: "/plugins/dropzone", name: "Dropzone" },
        { to: "/plugins/emoji-mart", name: "Emoji Mart" },
        { to: "/plugins/fontawesome", name: "Fontawesome" },

        { to: "/plugins/image-lightbox", name: "Image lightbox" },
        { to: "/plugins/lottie", name: "Lottie" },
        {
          to: "/plugins",
          name: "Map",
          children: [
            { to: "/plugins/leaflet-map", name: "Leaflet map" },
            { to: "/plugins/google-map", name: "Google map" },
            { to: "/plugins/echart-map", name: "Echart Map" },
          ],
        },
        { to: "/plugins/progressbar", name: "Progressbar" },
        { to: "/plugins/react-hook-form", name: "React Hook Form" },
        { to: "/plugins/select", name: "Select" },
        { to: "/plugins/slick-carousel", name: "Slick Carousel" },
        { to: "/plugins/scroll-bar", name: "Scroll Bar" },
        { to: "/plugins/toastify", name: "Toastify" },
        { to: "/plugins/typed", name: "Typed" },
        { to: "/plugins/wysiwyg", name: "WYSIWYG editor" },
      ],
    };

    utilityRoutes = {
      name: "Utilities",
      to: "/utilities",
      icon: ["fab", "hotjar"],
      children: [
        { to: "/utilities/borders", name: "Borders" },
        { to: "/utilities/clearfix", name: "Clearfix" },
        { to: "/utilities/closeIcon", name: "Close icon" },
        { to: "/utilities/colors", name: "Colors" },
        { to: "/utilities/display", name: "Display" },
        { to: "/utilities/embed", name: "Embed" },
        { to: "/utilities/figures", name: "Figures" },
        { to: "/utilities/flex", name: "Flex" },
        { to: "/utilities/grid", name: "Grid" },
        { to: "/utilities/sizing", name: "Sizing" },
        { to: "/utilities/spacing", name: "Spacing" },
        { to: "/utilities/stretchedLink", name: "Stretched link" },
        { to: "/utilities/typography", name: "Typography" },
        { to: "/utilities/verticalAlign", name: "Vertical align" },
        { to: "/utilities/visibility", name: "Visibility" },
      ],
    };
  } else if (user.role === 24) {
    homeRoutes = {
      name: "Home",
      to: "/",
      exact: true,
      icon: "home",
      children: [
        {
          to: "/",
          name: "Dashboard",
          icon: "chart-pie",
          exact: true,
        },
      ],
    };

    campaignRoutes = {
      name: "Video Campaigns",
      to: "/components",
      icon: "play",
      children: [
        { to: "/components/campaignReport", name: "Report" },
        // { to: "/components/campaignReport/new", name: "Report New" },
      ],
    };
    
  } else if (user.role === 25) { // Ad Ops
    homeRoutes = {
      name: "Home",
      to: "/",
      exact: true,
      icon: "home",
      children: [
        {
          to: "/",
          name: "Dashboard",
          icon: "chart-pie",
          exact: true,
        },
      ],
    };

    demandRoutes = {
      name: "Demand Manage",
      to: "/components",
      icon: "ad",
      children: [
        { to: "/components/demandSourceList", name: "Demand List" },
        { to: "/components/demandPartnerList", name: "Partner List" },
        { to: "/demand/mapping", name: "Demand Mapping" },
        { to: "/components/rtb/mapping", name: "RTB Mapping" },
      ],
    };

    superReportRoutes = {
      name: "Super Admin Report",
      to: "/components/superReport",
      icon: "user-tie",
    };

    demandReportRoutes = {
      name: "Demand Report",
      to: "/components/demandReport",
      icon: "poll",
    };

    revenueanalyticsreportroutes = {
      name: "Revenue Analytics ",
      to: "/components/revenueanalyticsreport",
      icon: "file-invoice-dollar",
    };

    outagereportroutes = {
      name: "Outage Report",
      to: "/components/outagereport",
      icon: "lock",
    };

    newLocationRoutes = {
      name: "Locations",
      to: "/components",
      icon: "map-marked",
      children: [
        { to: "/components/locationList", name: "List" },
        { to: "/components/locationAdd", name: "Add New" },
      ],
    };

    deviceRoutes = {
      name: "Devices",
      to: "/components",
      icon: "tv",
      children: [
        { to: "/components/deviceList", name: "List" },
        { to: "/components/deviceAdd", name: "Add New" },
        { to: "/components/device/enquiry", name: "Inquiry"},

      ],
    };

  } else if (user.role === 27){ // Campaign manager
    campaignRoutes = {
      name: "Video Campaigns",
      to: "/components",
      icon: "play",
      children: [
        { to: "/components/campaignList", name: "List" },
        { to: "/components/ActiveList", name: " Active List" },
        { to: "/components/campaignReport", name: "Report" },
        // { to: "/components/campaignReport/new", name: "Report New" },
      ],
    };

    creativeManagementRoutes = {
      name :"Creative Management",
      to : "/components",
      icon : "photo-video",
      children : [
        {to : "/components/creativeManageList", name : "List"},
        {to : "/components/creativeManageAdd", name : "Add New"},
      ],
    }
  } else if (user.role === 30){
    tenantRoutes = {
      name: "Tenant",
      to: "/components",
      icon: "building",
      children: [
        { to: "/components/tenant/list", name: "List" },
        { to: "/components/tenant/add", name: "Add New" },
      ],
    };
  }else if (user.role === 31) {
    deviceAppRoutes = {
      name: "Device Add",
      to: "/components/deviceInstallAdd",
      icon: "tv",
    };
    deviceAppListRoutes = {
      name: "Device List",
      to: "/components/deviceInstallList",
      icon: "tv",
    };
  } else if (user.role === 32) {
    deviceAppRoutes = {
      name: "Device Add",
      to: "/components/deviceInstallAdd",
      icon: "tv",
    };
    deviceAppListRoutes = {
      name: "Device List",
      to: "/components/deviceInstallList",
      icon: "tv",
    };
  }

  if (user.role === 26) {
    bandwidthReportRoutes = {
      name: "Bandwidth Report",
      to: "/components/bandwidthReport",
      icon: "wifi",
      exact: true,
    };
  }
}
let routes;
if (user) {
 if (user.role === 26 && user.user_id === 1228 && user.tenant_id === 335) {
    routes = [
      homeRoutes,
      clientRoutes,
      userNameRoutes,
      locationRoutes,
      deviceRoutes,
        bandwidthReportRoutes,
      demandRoutes,
      campaignRoutes,
      creativeManagementRoutes,
      superReportRoutes,
      userDetailsRoutes
    ];
  } else if (user.role === 26 && user.user_id === 1272 && user.tenant_id === 335) {
    routes = [
      homeRoutes,
      clientRoutes,
      userNameRoutes,
      locationRoutes,
      deviceRoutes,
        bandwidthReportRoutes,
      demandRoutes,
      campaignRoutes,
      creativeManagementRoutes,
      superReportRoutes,
      userDetailsRoutes
    ];
  }
  else if (user.role === 26 && user.tenant_id === 1) {
    routes = [
      homeRoutes,
      deviceRoutes,
        bandwidthReportRoutes,
      clientRoutes,
      demandRoutes,
      campaignRoutes,
      creativeManagementRoutes,
      display,
      superReportRoutes,
      revenueanalyticsreportroutes,
      merchantRoutes,
      demandReportRoutes,
      demographicRoutes,
      userNameRoutes,
      newLocationRoutes,
      userDetailsRoutes,
      outagereportroutes,
      partnerdetailsroutes,
      integrationroutes,
      healthreportroutes,
      templateroutes,
      videoAnalyticsReport,
      doohAnalyticsReport,
      reconciliationRoutes,
      serviceConfigurationRoutes,
    ];
  } else if (user.role === 26) {
    routes = [
      homeRoutes,
      deviceRoutes,
        bandwidthReportRoutes,
      clientRoutes,
      demandRoutes,
      campaignRoutes,
      creativeManagementRoutes,
      superReportRoutes,
      revenueanalyticsreportroutes,
      merchantRoutes,
      demandReportRoutes,
      demographicRoutes,
      userNameRoutes,
      newLocationRoutes,
      userDetailsRoutes,
      outagereportroutes,
      healthreportroutes,
      videoAnalyticsReport,
      doohAnalyticsReport
    ];
  } else if (user.role === 31) {
    routes = [
      deviceAppRoutes,
      deviceAppListRoutes
    ];
  } else if (user.role === 32) {
    routes = [
      deviceAppRoutes,
      deviceAppListRoutes
    ];
  } 
  else if (user.tenant_id === 335 && user.client_id === 117 && process.env.REACT_APP_ENVIRONMENT === "production") {
    let baseRoutes = [
      homeRoutes,
      ...(user.demandAdApproval ? [demandAdApprovalRoutes] : []),
      superReportRoutes,
    ];
    routes = baseRoutes;
  }
 else if (user.role === 1 && user.tenant_id === 335) {
    let baseRoutes = [
      homeRoutes,
      userNameRoutes,
      locationRoutes,
      deviceRoutes,
      //outageRoutes,
      //videoRoutes,
      //bannerRoutes,
      ...(user.client_id === 103 || user.client_id === 111 || user.client_id === 117 ? [] : [playlistRoutes]),
      doohPlaylistRoutes,
      ...(user.clientAdApproval ? [adApprovalRoutes] : []),
      ...(user.demandAdApproval ? [ demandAdApprovalRoutes] : []),
      campaignRoutes,
      creativeManagementRoutes,
      superReportRoutes,
      //userDetailsRoutes, hidded for now
      //videoAnalyticsReport,
      //doohAnalyticsReport
    ];
    routes = baseRoutes;
    }
else if (user.role === 1) {
    routes = [
      homeRoutes,
      deviceRoutes,
      outageRoutes,
      videoRoutes,
      bannerRoutes,
      playlistRoutes,
      doohPlaylistRoutes,
      campaignRoutes,
      ...(user.clientAdApproval ? [ adApprovalRoutes ] : []),
       ...(user.demandAdApproval ? [ demandAdApprovalRoutes] : []),
      creativeManagementRoutes,
      display,
      superReportRoutes,
      merchantRoutes,
      monthlyRoutes,
      userNameRoutes,
      newLocationRoutes,
      userDetailsRoutes,
      outagereportroutes,
      videoAnalyticsReport,
      doohAnalyticsReport
    ];
  } else if (user.role === 10) {
    routes = [
      homeRoutes,
      deviceRoutes,
      videoRoutes,
      bannerRoutes,
      playlistRoutes,
      doohPlaylistRoutes,
      ...(user.clientAdApproval && user.networkAdApproval ? [adApprovalRoutes] : []),
      campaignRoutes,
      superReportRoutes,
      monthlyRoutes,
      newLocationRoutes,
      userDetailsRoutes,
      outagereportroutes,
      videoAnalyticsReport,
      doohAnalyticsReport
    ];
  } else if (user.role === 12) {
    routes = [
      homeRoutes,
      deviceRoutes,
      superReportRoutes,
    ];
  } else if (user.role === 24) {
    routes = [
      advertiser_id !== "56" && homeRoutes,
      campaignRoutes,
    ];
  } else if (user.role === 25) { // Ad Ops
    routes = [
      homeRoutes,
      newLocationRoutes,
      deviceRoutes,
      demandRoutes,
      superReportRoutes,
      demandReportRoutes,
      revenueanalyticsreportroutes,
      outagereportroutes
    ];
  } else if (user.role === 27){ // Campaign manager
    routes =[
    campaignRoutes,
    creativeManagementRoutes
    ];
  } else if (user.role === 30) {
    routes = [
      tenantRoutes
    ];
  }
}
// Bandwidth Report is superadmin-only (role_id 26). Strip it from the resolved
// menu for every other role so the sidebar never shows a link that would 404.
if (user && Number(user.role) !== 26 && Array.isArray(routes)) {
  routes = routes.filter((r) => !(r && r.to === "/components/bandwidthReport"));
}

export default routes;
